import { Globe } from 'lucide-react';

import { NodeShell } from './NodeShell';

export const CallApiNode = ({
  data,
  selected,
}: {
  data: { label: string; method?: string; url?: string };
  selected?: boolean;
}) => (
  <NodeShell
    type="call_api"
    icon={<Globe size={16} />}
    label={data.label}
    subtitle={data.method && data.url ? `${data.method} ${data.url}` : undefined}
    selected={selected}
  />
);
